import React from 'react';
export var NCContext = React.createContext({});
NCContext.displayName = 'NCContext';
//# sourceMappingURL=NCContext.js.map